// const BASE_URL = 'http://sf4valor.ibermasters.com/api/form/';
// const BASE_URL = 'https://127.0.0.1:8000/api/form/';
const BASE_URL = '/api/form/';

export async function init(uid) {
    try {
        const uidURLString = uid ? `/${uid}` : '';
        const response = await fetch(`${BASE_URL}loan/init${uidURLString}`);

        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
    }
}

export async function sendSmsCode(uid) {

    try {
        const response = await fetch(`${BASE_URL}loan/resend-sms-code/${uid}`, getHeaders());
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
    }
}

export async function postPhoneNumber(formData, uid) {

    const body = {
        telMovil: formData.telMovil
    };

    try {
        const response = await fetch(`${BASE_URL}loan/update-phone/${uid}`, getHeaders(body));
        const data = await response.json();

        if (data?.success) {
            return data;
        } else if (data?.formErrors?.form?.code === 400) {
            return {
                success: false,
                errors: {
                    telMovil: getFieldError(data, 'telMovil'),
                }
            }
        }

        return data;

    } catch (error) {
        console.error(error);
    }
}

export async function postIdPhone(formData) {

    const body = {
        nombre: formData.nombre,
        apellido: formData.apellido,
        ci: formData.ci,
        userFechaNac: trasnformDateToSend(formData.userFechaNac),
        sexo: formData.sexo,
        ocupacion: formData.ocupacion,
        rut: formData.rut,
        antiguedad: formData.antiguedad,
        ingresos: formData.ingresos,
        hasReciboSueldo: formData.hasReciboSueldo === 'true',
        email: formData.email,
        telMovil: formData.telMovil,
        agreeTerms: formData.agreeTerms,
    };

    try {
        const response = await fetch(`${BASE_URL}loan/id-phone`, getHeaders(body));
        const data = await response.json();

        if (data?.success) {
            return data;
        } else if (data?.formErrors?.form?.code === 400) {
            return {
                success: false,
                errors: {
                    nombre: getFieldError(data, 'nombre'),
                    apellido: getFieldError(data, 'apellido'),
                    ci: getFieldError(data, 'ci'),
                    userFechaNac: getFieldError(data, 'userFechaNac'),
                    sexo: getFieldError(data, 'sexo'),
                    ocupacion: getFieldError(data, 'ocupacion'),
                    rut: getFieldError(data, 'rut'),
                    antiguedad: getFieldError(data, 'antiguedad'),
                    ingresos: getFieldError(data, 'ingresos'),
                    hasReciboSueldo: getFieldError(data, 'hasReciboSueldo'),
                    email: getFieldError(data, 'email'),
                    telMovil: getFieldError(data, 'telMovil'),
                    agreeTerms: getFieldError(data, 'agreeTerms'),
                }
            }
        }

        return data;
    } catch (error) {
        console.error(error);
    }
}

export async function postSmsCode(formData, uid) {

    const body = {
        userCodigoValidacion: formData.userCodigoValidacion,
        userFechaNac: trasnformDateToSend(formData.userFechaNac)
    };

    try {
        const response = await fetch(`${BASE_URL}loan/sms-code/${uid}`, getHeaders(body));
        const data = await response.json();

        if (data?.success) {
            return data;
        } else if (data?.formErrors?.form?.code === 400) {
            return {
                success: false,
                errors: {
                    userCodigoValidacion: getFieldError(data, 'userCodigoValidacion'),
                    userFechaNac: getFieldError(data, 'userFechaNac')
                }
            }
        }

        return data;
    } catch (error) {
        console.error(error);
    }
}

export async function postLoanOptions(formData, uid) {

    const body = {
        solicitudTipo: formData.solicitudTipo,
        financialProducto: formData.financialProducto,
        monto: formData.monto,
        cantidadCuotas: formData.cantidadCuotas,
        valorCuota: formData.valorCuota,
        diagramaPrimerVencimiento: formData.primerVto,
    };

    try {
        const response = await fetch(`${BASE_URL}loan/product/${uid}`, getHeaders(body));

        const data = await response.json();

        if (data?.success) {
            return data;
        } else if (data?.formErrors?.form?.code === 400) {
            return {
                success: false,
                errors: {
                    solicitudTipo: getFieldError(data, 'solicitudTipo'),
                    financialProducto: getFieldError(data, 'financialProducto'),
                    monto: getFieldError(data, 'monto'),
                    cantidadCuotas: getFieldError(data, 'cantidadCuotas'),
                    valorCuota: getFieldError(data, 'valorCuota'),
                    diagramaPrimerVencimiento: getFieldError(data, 'diagramaPrimerVencimiento'),
                }
            }
        }

        return data;
    } catch (error) {
        console.error(error);
    }
}

export async function postIdData(formData, uid) {

    const body = {
        estadoCivil: formData.estadoCivil,
        ciConcubino: formData.ciConcubino,
        nombreConcubino: formData.nombreConcubino,
        apellidoConcubino: formData.apellidoConcubino,
        nacionalidad: formData.nacionalidad,
        nivelEstudio: formData.nivelEstudio,
        nroSerie: formData.nroSerie,
        nroIdentificacion: formData.nroIdentificacion,
        inListaPep: formData.inListaPep === 'true',
        agreeBeneficiarioFinal: formData.agreeBeneficiarioFinal,
    };

    try {
        const response = await fetch(`${BASE_URL}loan/data/${uid}`, getHeaders(body));
        const data = await response.json();

        if (data?.success) {
            return data;
        } else if (data?.formErrors?.form?.code === 400) {
            return {
                success: false,
                errors: {
                    estadoCivil: getFieldError(data, 'estadoCivil'),
                    ciConcubino: getFieldError(data, 'ciConcubino'),
                    nombreConcubino: getFieldError(data, 'nombreConcubino'),
                    apellidoConcubino: getFieldError(data, 'apellidoConcubino'),
                    nacionalidad: getFieldError(data, 'nacionalidad'),
                    nivelEstudio: getFieldError(data, 'nivelEstudio'),
                    nroSerie: getFieldError(data, 'nroSerie'),
                    nroIdentificacion: getFieldError(data, 'nroIdentificacion'),
                    inListaPep: getFieldError(data, 'inListaPep'),
                    agreeBeneficiarioFinal: getFieldError(data, 'agreeBeneficiarioFinal'),
                }
            }
        }

        return data;
    } catch (error) {
        console.error(error);
    }
}

export async function postAddress(formData, uid) {

    const body = {
        direccionParticular: formData.direccionParticular,
        numeroPuerta: formData.numeroPuerta,
        apartamento: formData.apartamento,
        departamento: formData.departamento,
        ciudad: formData.ciudad,
        telParticular: formData.telParticular,
        telExtra: formData.telExtra,
        departamentoNac: formData.departamentoNac,
    };

    try {
        const response = await fetch(`${BASE_URL}loan/address/${uid}`, getHeaders(body));
        const data = await response.json();

        if (data?.success) {
            return data;
        } else if (data?.formErrors?.form?.code === 400) {
            return {
                success: false,
                errors: {
                    direccionParticular: getFieldError(data, 'direccionParticular'),
                    numeroPuerta: getFieldError(data, 'numeroPuerta'),
                    apartamento: getFieldError(data, 'apartamento'),
                    departamento: getFieldError(data, 'departamento'),
                    ciudad: getFieldError(data, 'ciudad'),
                    telParticular: getFieldError(data, 'telParticular'),
                    telExtra: getFieldError(data, 'telExtra'),
                    departamentoNac: getFieldError(data, 'departamentoNac'),
                }
            }
        }

        return data;
    } catch (error) {
        console.error(error);
    }
}

export async function postGestureFile(body, uid) {
    return uploadFile('loan/gesto-upload', body, uid);
}

export async function postIdFrontFile(body, uid) {
    return uploadFile('loan/ci-frente-upload', body, uid);
}

export async function postIdBackFile(body, uid) {
    return uploadFile('loan/ci-dorso-upload', body, uid);
}

export async function postSalaryFile(body, uid) {
    return uploadFile('loan/recibo-sueldo-upload', body, uid);
}

export async function postProofAddressFile(body, uid) {
    return uploadFile('loan/constancia-domicilio-upload', body, uid);
}

export async function getLoanDefaultOptions(uid) {
    try {
        const response = await fetch(`${BASE_URL}loan/options-defaults/${uid}`);

        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
    }
}

export async function getLoanOptions(uid, amount, type) {
    try {
        const response = await fetch(`${BASE_URL}loan/options-amount/${uid}?monto=${amount}&tipo=${type}`);

        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
    }
}

// ---------------- Helper functions ---------------- //

async function uploadFile(path, body, uid) {
    try {
        const response = await fetch(`${BASE_URL}${path}/${uid}`, {
            method: 'POST',
            'Content-Type': 'multipart/form-data',
            accept: 'application/json',
            mode: 'cors',
            cache: 'no-cache',
            body
        });
        const data = await response.json();

        if (data?.success) {
            return data;
        } else if (data?.formErrors?.form?.code === 400) {
            return {
                success: false,
                errors: {}
            }
        }

        return data;
    } catch (error) {
        console.error(error);
    }
}

function getFieldError(data, fieldName) {
    const errors = data?.formErrors?.form?.errors?.children;

    if (errors && errors[fieldName]) {
        const fieldErrors = errors[fieldName]?.errors;
        if (fieldErrors && fieldErrors[0]) return fieldErrors[0];
    }

    return null;
}

function getHeaders(body, method = 'POST') {
    return {
        method,
        // 'Content-Type': 'application/json',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(body)
    }
}

function padDate(datePart) {
    if (datePart.length === 2) return datePart;
    return `0${datePart}`;
}

function trasnformDateToSend(date) {
    const dateParts = date.split('/');

    return `${dateParts[2]}-${padDate(dateParts[1])}-${padDate(dateParts[0])}`
}
